import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@repo/ui";
import { Alert, AlertDescription } from "@repo/ui";
import { StardeckSignInButton, useAuth } from "@stardeck-customer-apps/project-auth";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { ExpoLogo } from "@/components/expo-logo";

export default function AdminLogin() {
  const { user, isLoading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");

  const returnTo = searchParams.get("returnTo") || "/admin";
  const errorParam = searchParams.get("error");

  useEffect(() => {
    if (user && !authLoading) {
      navigate(returnTo, { replace: true });
    }
  }, [user, authLoading, navigate, returnTo]);

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="size-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (user) {
    return null;
  }

  const errorMessage = errorParam || error;

  return (
    <div className="min-h-screen flex flex-col items-center bg-background px-4 py-12">
      <div className="mb-6">
        <ExpoLogo to="/admin" />
      </div>
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold tracking-tight">Sign in to your Admin Dashboard</h1>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Sign in</CardTitle>
            <CardDescription>Use your Stardeck account to continue</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            {errorMessage && (
              <Alert variant="destructive">
                <AlertDescription>{errorMessage}</AlertDescription>
              </Alert>
            )}

            <StardeckSignInButton
              style={{ width: "100%" }}
              signInPath="/admin/login"
              onSuccess={() => navigate(returnTo, { replace: true })}
              onError={(err) => setError(err.message)}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
